import React, { Component } from "react";
        import {
        EditorState,
                convertToRaw,
                convertFromRaw,
                ContentState,
                convertFromHTML,
                CompositeDecorator,
        } from "draft-js";
        import Editor, { createEditorStateWithText } from "@draft-js-plugins/editor";
        import { stateToHTML } from "draft-js-export-html";
        import SimpleEmoji, { emojiPlugin } from "./SimpleEmoji";
        import SimpleUndo, { undoPlugin } from "./SimpleUndo";
        import StaticToolbar, { toolbarPlugin } from "./StaticToolbar";
        import "./customToolbarEditor.css";
        import "@draft-js-plugins/hashtag/lib/plugin.css";
        import createHighlightPlugin from "draft-js-highlight-plugin";
        import createHashtagPlugin from "@draft-js-plugins/hashtag";
        import createLinkifyPlugin from "@draft-js-plugins/linkify";
        import MentionTool, { mentionPlugin } from "./MentionTool";
        import htmlToDraft from "html-to-draftjs";
        import Dropzone from "./Dropzone";
        const linkifyPlugin = createLinkifyPlugin();
        const hashtagPlugin = createHashtagPlugin();
        const highlightPlugin = createHighlightPlugin({
        background: "purple",
                color: "yellow",
                border: "1px solid black",
        });
        const plugins = [
                toolbarPlugin,
                emojiPlugin,
                linkifyPlugin,
                hashtagPlugin,
                undoPlugin,
                mentionPlugin,
                highlightPlugin,
        ];
        const text = "<p></p>";
        const content = convertFromHTML(text);
        const state = ContentState.createFromBlockArray(
                content.contentBlocks,
                content.entityMap
                );
        export default class ToolBar extends Component {
        constructor(props) {
        super(props);
                this.state = {
                newEditorValue: [],
                        editorState:
                        plugins === toolbarPlugin || emojiPlugin || undoPlugin || hashtagPlugin
                        ? EditorState.createWithContent(state)
                        : EditorState.createEmpty(),
                        editorJSON: [],
                        content_value: ''
                };
        }

        componentDidUpdate = () => {
        if (this.props.content_data){
        var get_content_data = this.props.content_data;
                var blocksFromHTML = get_content_data ? convertFromHTML(get_content_data):"";
                var contentState = blocksFromHTML ? ContentState.createFromBlockArray(
                        blocksFromHTML.contentBlocks,
                        blocksFromHTML.entityMap
                        ):{};
                var editorstate = EditorState.createWithContent(contentState);
                if (this.state.content_value == ''){
        this.setState(
        {
        ...this.state,
                editorState:editorstate,
                content_value:1,
        },
                () => {}
        );
        }
        }
        };
                onChange = (editorState) => {
        const editorJSON = JSON.stringify(
                convertToRaw(this.state.editorState.getCurrentContent())
                );
                this.setState(
                {
                editorState: editorState,
                        editorJSON: editorJSON,
                },
                        () => {}
                );
                let editorText = stateToHTML(this.state.editorState.getCurrentContent());
                this.props.toolbarData(
                        editorText.length ? editorText : stateToHTML(this.props.content_data)
                        );
        };
                focus = () => {
        this.editor.focus();
        };
                onClick = () => {
        const temp = JSON.parse(this.state.editorJSON);
                const mention = (temp, key) => {
        const arr = mention["entityMap"];
                if (arr.length) {
        const result = arr.map((item) => {
        });
        } else {
        return null;
        }
        };
                let html = stateToHTML(this.state.editorState.getCurrentContent());
        };
                render() {
        return (
<>

<div className="editor" onClick={this.focus}>
    <Editor
        editorState={this.state.editorState}
        onChange={this.onChange}
        plugins={plugins}
        ref={(element) => {
        this.editor = element;
        }}
        />
    <MentionTool />
    {/* <Dropzone /> */}
</div>
<div className="allTools">
    <StaticToolbar />
    <SimpleEmoji />
</div>
{/* <button class="muBtn _blue" title="Submit" onClick={this.onClick}>
 Save
 </button> */}
</>
                );
        }
        }
